<script setup lang="ts">
import { DropdownMenuItem } from '@/components/ui/dropdown-menu'

const { elementalId } = defineProps<{
  elementalId: string
}>()

const { copied, copy } = useClipboard()

const copyId = () => {
  copy(elementalId.toString())
}

defineOptions({
  name: 'CopyIdOption',
})
</script>

<template>
  <DropdownMenuItem @select.prevent="copyId">
    <div v-if="copied" i-mdi:check w-3 h-3 />
    <IconElementalId v-else w-3 h-3 />
    {{ elementalId.toString().slice(0, 18) }}
  </DropdownMenuItem>
</template>
